
import {PropType,ref} from "vue";
import {IProduct} from "@/types/models/IProduct";
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Thumbs } from 'swiper';
import 'swiper/css';
import 'swiper/css/thumbs';
import 'swiper/css/free-mode';
export default {
  name: "product-single",
  props: {
    product: Object as PropType<IProduct>
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  setup() {
    const thumbsSwiper = ref(null);
    const setThumbsSwiper = (swiper: any) => {
      thumbsSwiper.value = swiper;
    };
    return {
      Thumbs,
      thumbsSwiper,
      setThumbsSwiper,
    };
  },
}
